import {gql} from "@apollo/client";

export const GET_JOB_RUNS = gql`
	query GetJobRuns(
		$jobId: Int
		$before: String
		$after: String
		$first: Int
		$last: Int
		$where: [JobRunFilterInput!]
		$order: [JobRunSortInput!]
	) {
		jobRun (
			before: $before
			after: $after
			first: $first
			last: $last
			where: { job: { id: { eq: $jobId } }, and: $where }
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				start
				finish
				description
				graphQlQuery
			   job {
					description
					jobDefinition {
						description
						jobSteps {
							id
							description
							order
						}
					}
				}
				jobStepRuns {
					id
					total
					failed
					succeeded
					cancel
					start
					finish
				}
			}
		}
	}
`;
